class ReferralsDashboard {
	constructor() {
		this.container = document.querySelector(".referrals-dashboard");
		if (!this.container) return;

		this.apiUrl = this.container.dataset.apiUrl;
		this.memberId = this.container.dataset.memberId;
		this.apiUrlMember = this.container.dataset.apiUrlMember;
		this.signature = this.container.dataset.signature;
		this.shareText = this.container.dataset.shareText || "";

		this.currentTab = "invite-friends";
		this.referralLink = "";
		this.referralCode = "";

		this.init();
	}

	init() {
		this.setupTabs();
		this.setupCopyButton();
		this.setupSocialShare();
		this.fetchReferralData();
	}

	setupTabs() {
		const tabButtons = document.querySelectorAll(".referrals-tab");
		tabButtons.forEach((button) => {
			button.addEventListener("click", () => this.switchTab(button));
		});
	}

	switchTab(button) {
		const targetTab = button.dataset.tab;

		document.querySelectorAll(".referrals-tab").forEach((tab) => {
			tab.classList.remove("referrals-tab--active");
		});
		button.classList.add("referrals-tab--active");

		document.querySelectorAll(".referrals-tab-content").forEach((content) => {
			content.classList.remove("referrals-tab-content--active");
		});
		const targetContent = document.querySelector(
			`[data-tab-content="${targetTab}"]`
		);
		if (targetContent) {
			targetContent.classList.add("referrals-tab-content--active");
		}

		this.currentTab = targetTab;

		if (targetTab === "your-rewards" && !this.rewardsLoaded) {
			this.fetchRewardsData();
		}
	}

	setupCopyButton() {
		const copyBtn = document.querySelector('[data-action="copy-link"]');
		if (!copyBtn) return;

		copyBtn.addEventListener("click", () => this.copyReferralLink());
	}

	async copyReferralLink() {
		const input = document.getElementById("referral-link");
		const feedback = document.querySelector(".referrals-invite__copy-feedback");
		const copyBtn = document.querySelector('[data-action="copy-link"]');

		if (!input || !this.referralLink) return;

		try {
			await navigator.clipboard.writeText(this.referralLink);

			if (copyBtn) {
				const originalText = copyBtn.textContent;
				copyBtn.textContent = "Copied!";
				setTimeout(() => {
					copyBtn.textContent = originalText;
				}, 2000);
			}
		} catch (err) {
			console.error("Failed to copy:", err);
			input.select();
			document.execCommand("copy");

			if (feedback) {
				feedback.textContent = "Link copied!";
				feedback.classList.add("success");
				setTimeout(() => {
					feedback.textContent = "";
					feedback.classList.remove("success");
				}, 3000);
			}
		}
	}

	setupSocialShare() {
		const facebookBtn = document.querySelector(
			'[data-action="share-facebook"]'
		);
		const messengerBtn = document.querySelector(
			'[data-action="share-facebook-messenger"]'
		);
		const whatsappBtn = document.querySelector(
			'[data-action="share-whatsapp"]'
		);
		const xBtn = document.querySelector('[data-action="share-x"]');
		const telegramBtn = document.querySelector(
			'[data-action="share-telegram"]'
		);

		if (facebookBtn) {
			facebookBtn.addEventListener("click", () => this.shareOnFacebook());
		}
		if (messengerBtn) {
			messengerBtn.addEventListener("click", () => this.shareOnMessenger());
		}
		if (whatsappBtn) {
			whatsappBtn.addEventListener("click", () => this.shareOnWhatsApp());
		}
		if (xBtn) {
			xBtn.addEventListener("click", () => this.shareOnX());
		}
		if (telegramBtn) {
			telegramBtn.addEventListener("click", () => this.shareOnTelegram());
		}
	}

	shareOnFacebook() {
		if (!this.referralLink) return;
		const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
			this.referralLink
		)}`;
		window.open(url, "_blank", "width=600,height=400");
	}

	shareOnMessenger() {
		if (!this.referralLink) return;
		const url = `https://www.facebook.com/dialog/send?link=${encodeURIComponent(
			this.referralLink
		)}&app_id=YOUR_APP_ID&redirect_uri=${encodeURIComponent(window.location.href)}`;
		window.open(url, "_blank", "width=600,height=400");
	}

	shareOnWhatsApp() {
		if (!this.referralLink) return;
		const text = `${this.shareText} ${this.referralLink}`.trim();
		const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
		window.open(url, "_blank", "width=600,height=400");
	}

	shareOnX() {
		if (!this.referralLink) return;
		const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
			this.referralLink
		)}&text=${encodeURIComponent(this.shareText)}`;
		window.open(url, "_blank", "width=600,height=400");
	}

	shareOnTelegram() {
		if (!this.referralLink) return;
		const url = `https://t.me/share/url?url=${encodeURIComponent(
			this.referralLink
		)}&text=${encodeURIComponent(this.shareText)}`;
		window.open(url, "_blank", "width=600,height=400");
	}

	async fetchReferralData() {
		try {
			const response = await fetch(
				`${this.apiUrlMember}/referrer?signature=${this.signature}`,
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"X-Signature": this.signature,
					},
				}
			);

			if (!response.ok) {
				throw new Error("Failed to fetch referral data");
			}

			const data = await response.json();

			if (data.code && data.url) {
				this.referralCode = data.code;
				this.referralLink = data.url;

				const input = document.getElementById("referral-link");
				if (input) {
					input.value = this.referralLink;
				}
			} else {
				const input = document.getElementById("referral-link");
				if (input) {
					input.value = "Referral link not available";
					input.disabled = true;
				}
				const copyBtn = document.querySelector('[data-action="copy-link"]');
				if (copyBtn) {
					copyBtn.disabled = true;
				}
			}
		} catch (error) {
			console.error("Error fetching referral data:", error);
			const input = document.getElementById("referral-link");
			if (input) {
				input.value = "Unable to load referral link";
				input.disabled = true;
			}
		}
	}

	async fetchRewardsData() {
		const loadingEl = document.querySelector(".referrals-rewards__loading");
		const listEl = document.querySelector(".referrals-rewards__list");
		const emptyEl = document.querySelector(".referrals-rewards__empty");
		const errorEl = document.querySelector(".referrals-rewards__error");

		if (loadingEl) loadingEl.style.display = "block";
		if (listEl) listEl.style.display = "none";
		if (emptyEl) emptyEl.style.display = "none";
		if (errorEl) errorEl.style.display = "none";

		try {
			const response = await fetch(
				`${this.apiUrlMember}/referrer/rewards?signature=${this.signature}`,
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"X-Signature": this.signature,
					},
				}
			);

			if (!response.ok) {
				throw new Error("Failed to fetch rewards data");
			}

			const response_data = await response.json();
			const rewardedReferrals = Array.isArray(response_data.data)
				? response_data.data
				: [];

			if (loadingEl) loadingEl.style.display = "none";

			if (rewardedReferrals.length === 0) {
				if (emptyEl) emptyEl.style.display = "block";
			} else {
				this.renderRewards(rewardedReferrals);
				if (listEl) listEl.style.display = "block";
			}

			this.rewardsLoaded = true;
		} catch (error) {
			console.error("Error fetching rewards data:", error);
			if (loadingEl) loadingEl.style.display = "none";
			if (errorEl) errorEl.style.display = "block";
		}
	}

	renderRewards(referrals) {
		const tbody = document.querySelector(".referrals-rewards__table tbody");
		if (!tbody) return;

		tbody.innerHTML = "";

		referrals.forEach((referral) => {
			const row = document.createElement("tr");

			const dateCell = document.createElement("td");
			if (referral.date) {
				const date = new Date(referral.date);
				const mm = String(date.getMonth() + 1).padStart(2, "0");
				const dd = String(date.getDate()).padStart(2, "0");
				const yy = String(date.getFullYear()).slice(-2);
				dateCell.textContent = `${mm}.${dd}.${yy}`;
			} else {
				dateCell.textContent = "N/A";
			}
			row.appendChild(dateCell);

			const refereeCell = document.createElement("td");
			refereeCell.className = "text-uppercase";
			refereeCell.textContent = referral.referee?.email || "N/A";
			row.appendChild(refereeCell);

			const rewardCell = document.createElement("td");
			rewardCell.textContent = referral.amount ? `$${referral.amount}` : "$0";
			row.appendChild(rewardCell);

			const statusCell = document.createElement("td");
			const statusBadge = document.createElement("span");
			statusBadge.className = "badge text-uppercase";

			if (referral.status === "completed" || referral.status === "active") {
				statusBadge.classList.add("badge-active");
				statusBadge.textContent = "Active";
			} else if (referral.status === "pending") {
				statusBadge.classList.add("badge-pending");
				statusBadge.textContent = "Pending";
			} else {
				statusBadge.classList.add("badge-default");
				statusBadge.textContent = referral.status || "Processing";
			}

			statusCell.appendChild(statusBadge);
			row.appendChild(statusCell);

			tbody.appendChild(row);
		});
	}
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", () => {
		window.referralsDashboard = new ReferralsDashboard();
	});
} else {
	window.referralsDashboard = new ReferralsDashboard();
}
